import { createContext, ReactNode, useContext } from "react";

interface MsalConfigContextProps {
  tenantName: string;
  signInSignUpPolicy: string;
  applicationId: string;
  redirectUri: string;
}

const MsalConfigContext = createContext<MsalConfigContextProps | undefined>(
  undefined,
);

export const MsalConfigProvider = ({
  children,
  tenantName,
  signInSignUpPolicy,
  applicationId,
  redirectUri,
}: MsalConfigContextProps & { children: ReactNode }) => {
  return (
    <MsalConfigContext.Provider
      value={{
        tenantName,
        signInSignUpPolicy,
        applicationId,
        redirectUri,
      }}
    >
      {children}
    </MsalConfigContext.Provider>
  );
};

export const useMsalConfigContext = () => {
  const context = useContext(MsalConfigContext);
  if (!context) {
    throw new Error("useMsalContext must be used within a MsalProvider");
  }
  return context;
};
